import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../Sponsors';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import VideoBackground from '../../components/VideoBackground';
import { Link } from 'react-router-dom';

const HeaderLayout: React.FC = ({ children }) => {
  return (<></>
  );
};

export default HeaderLayout;
